<template>
    <q-layout view="hHh Lpr fFf" :style="loginFromOpen ? 'min-height: 700px !important;' : ''">

        <!-- Navbar -->
        <q-layout-header class="header-style" :style="$route.name !== 'home' && !isMobile ? 'z-index: 1!important;' : ''" @click.native="closeToolbar">
            <navbar v-if="$route.name === 'home' && !isMobile" @menuHome="menuHome" :noBorder="homeMenu" :sideMenuOpen="homeMenu"></navbar>
            <navbar v-if="isMobile" @leftDrawerToogle="leftDrawerToogle" :sideMenuOpen="left" :class="loginFromOpen ? 'push-navbar-bottom' : ''"></navbar>
            <navbar v-else-if="$route.name !== 'home'" :sideMenuOpen="miniState"></navbar>
        </q-layout-header>

        <!-- Left Side Panel -->
        <q-layout-drawer :width="getWindowWidth" side="left" v-model="left" behavior="mobile" v-if="isMobile" @click.native="closeToolbar">
            <v-menu @closeMenu="closeMenu" :items="menusFiltered" :class="loginFromOpen ? 'push-navbar-bottom' : ''"></v-menu>
        </q-layout-drawer>
        <q-layout-drawer v-model="leftDesktop" :mini="miniState" v-if="$route.name !== 'home' && !isMobile" :width="300" :overlay="overlay" side="left" behavior="desktop" @click.native.prevent.stop="closeToolbar">
            <v-menu @leftDrawerToogleDesktop="leftDrawerToogleDesktop" :stateMenu="stateMenu" @changeMenu="changeMenu($event)" :items="menusFiltered"></v-menu>
            <div v-if="$route.name !== 'home' && !isMobile" slot="mini">
              <div class="p-btn-menu row">
                <v-button flat dense round @click.native="openLateralMenu" color="primary" icon="fa icon-hamburger-menu"></v-button>
              </div>
              <template v-for="rootItem in menusFiltered">
                <q-item class="q-pa-md" item exact :to="{ name: rootItem.route }" @click.native.prevent.stop="changeStateMenu">
                    <q-item-side class="icon-lg" :icon="rootItem.icon"/>
                </q-item>
              </template>
            </div>
        </q-layout-drawer>
        <q-layout-drawer v-if="$route.name === 'home' && !isMobile" :width="300" side="left" v-model="homeMenu" :overlay="true" behavior="desktop">
            <v-menu @closeMenu="closeMenu" :items="menusFiltered"></v-menu>
        </q-layout-drawer>

        <!-- Content -->
        <q-page-container class="bg-white" id="app_content" @click.native="closeToolbar">
            <child :style="loginFromOpen ? 'min-height: unset !important;' : ''"/>
        </q-page-container>

        <!-- Footer -->
        <q-layout-footer @click.native="closeToolbar">
            <div style="padding: .5rem; background-color: #34303D"
                 class="row items-center justify-end text-white">
                Tecnología PDM / &copy; 2018 - 2025 Philip Morris Limited
            </div>
        </q-layout-footer>

        <!-- Helper tour -->
        <v-tour name="helpTour"></v-tour>
    </q-layout>
</template>

<script>
    import {mapGetters} from 'vuex'
    import Navbar from '../components/Navbar'
    import VMenu from '../components/Menu'
    import menuItems from '../menuItems'
    import store from "../store";
    import axios from 'axios'

    import {
        QLayout,
        QLayoutHeader,
        QLayoutFooter,
        QLayoutDrawer,
        QPageContainer
    } from 'quasar-framework'
import methods from '../helpers/methods'

    export default {
        mixins: [menuItems],
        name: 'MainLayout',

        components: {
            Navbar,
            VMenu,
            QLayout,
            QLayoutHeader,
            QLayoutFooter,
            QLayoutDrawer,
            QPageContainer
        },

        data() {
            return {
                left: false,
                leftDesktop: true,
                homeMenu: false,
                sideMenuOpen: false,
                loginFromOpen: false,
                isMobile: false,
                miniState: true,
                overlay: null,
                menusFiltered: [],
                mockData: null
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
            }),

            getWindowWidth() {
                return window.innerWidth
            },
            stateMenu(){
              return { leftDesktop: true, miniState: this.miniState }
            }
        },

        mounted() {
            this.isMobile = this.$q.platform.is.mobile || this.$q.platform.is.ipad || this.$q.platform.is.platform === 'ipad' || this.$q.platform.has.touch
            this.$root.$on('loginFromOpen', () => {
                this.loginFromOpen = true
            })
            this.getMockData()
            if(this.user.role.name === 'Lending Point' || this.user.role.name === 'Sales Expert' || this.user.role.name === 'MUPI' || user.role.name == 'Remote Coach'){
              if(this.$route.name === 'sales-expert.order' || this.$route.name === 'lending-point.order' || this.$route.name === 'lending-point.lending-kits.add'){
                this.overlay = false
                this.leftDesktop = true
              } else {
                this.overlay = true
                this.leftDesktop = true
              }
            }
        },

        updated(){
          if(this.user.role.name === 'Lending Point' || this.user.role.name === 'Sales Expert' || this.user.role.name === 'MUPI' || user.role.name == 'Remote Coach'){
            if(this.$route.name === 'sales-expert.order' || this.$route.name === 'lending-point.order' || this.$route.name === 'lending-point.lending-kits.add'){
              this.overlay = false
              this.leftDesktop = true
            } else {
              this.overlay = true
              this.leftDesktop = true
            }
          }
        },

        methods: {
          menuHome(){
            this.homeMenu = !this.homeMenu
          },
          openLateralMenu(){
            this.miniState = !this.miniState
          },
          changeMenu(stateObj){
            this.miniState = !(stateObj.miniState)
            this.leftDesktop = stateObj.leftDesktop
          },
          changeStateMenu(){
            this.miniState = true
            this.leftDesktop = true
          },
          leftDrawerToogleDesktop(){
            this.miniState = !this.miniState
          },
          async getMockData() {
                const {data} = await axios.get(`${config.appUrl}/api/v1/home/kpis`)
                this.mockData = data.data
                this.validateMenus()
            },
          canISeeThis(role) {
                return role instanceof Array ?
                    role.includes(this.user.role.name) :
                    role == this.user.role.name
            },
            marketCanSeeThis(role){
                return role instanceof Array ?
                role.includes(this.user.market.abbreviation) || role.includes('*') :
                role == this.user.market.abbreviation

            },
            menuIn(list) {
                return list.reduce((flat, item) => flat.concat(item.children ? item.children : item), [])
                    .filter(item => item.widget && this.canISeeThis(item.role))
                    .filter(item => item.widget && this.marketCanSeeThis(item.market))
            },
            validateMenus() {
                let user = store.getters['auth/user']
                let menus = this.menuItems;
                let newMenus = [];
                for (let i=0; i < menus.length; i++) {
                    if (menus[i].route === 'lending-point.order' || menus[i].route === 'sales-expert.order') {
                        if (user.lending_point && user.lending_point.enable_lending_creation) {
                            newMenus.push(menus[i])
                        }
                    } else if (menus[i].route === 'lending-point.lending-kits.add') {
                        if (this.mockData && this.mockData.canViewAddLendingKitsMenu) {
                            newMenus.push(menus[i])
                        }
                    } else if (menus[i].label === 'external return'){
                        if (this.mockData.externalReturn === '1'){
                            newMenus.push(menus[i])
                        }
                    }  else if (menus[i].label === 'kit reservation at POS') {
                      user.market.configurations.filter(config => {
                        if (config.description === 'enable_kit_reservation' && parseInt(config.pivot.value) === 1) newMenus.push(menus[i])
                      })
                    } else if (menus[i].label === 'partners'){
                      user.market.configurations.filter(config => {
                        if (config.description === 'enable_partner_to_remote_coach' && parseInt(config.pivot.value) === 1) newMenus.push(menus[i])
                      })
                    } else {
                        newMenus.push(menus[i])
                    }
                }
                this.menusFiltered = this.menuIn(newMenus);
            },

            leftDrawerToogle() {
                this.left = !this.left
            },

            closeMenu() {
                this.left = !this.left
            },

            closeToolbar(event) {
                this.$root.$emit('closeToolbar', event)
            }
        }
    }
</script>

<style>
.text-white {
  color: #FFFDF8 !important;
}

.q-layout-drawerx,
.q-popoverx,
.q-tabx,
.bg-whitex{
  background: #FFFFFF !important;
}

.bg-info {
  background: #287baf !important;
}

.bg-positive {
  background: #00d1d2 !important;
}

body,
.text-dark,
.q-table
{
  color: #34303d !important;
}

.q-if-label
{
  color: #524F5A !important;
}

.q-input-target,
.q-table th,
.q-table-bottom
{
  color: #34303D !important;
}

.q-chip {
  color: #34303d;
  background: #E1E0E2;
}

.text-red {
  color: #db3624 !important;
}

.q-table tbody td {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/layouts/default.vue